'use client'

import { datadogLogs } from '@datadog/browser-logs'

import { useDatadogStore } from '@state/use-datadog-store'

export function initDatadog(options: Parameters<typeof datadogLogs.init>[0]) {
  const { isInitialized } = useDatadogStore.getState()
  if (!isInitialized) {
    datadogLogs.init(options)
    useDatadogStore.setState({ isInitialized: true })
  }
  return datadogLogs
}

export { datadogLogs }
